'use client'

import { type Table } from '@tanstack/react-table'
import { RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { PostPurchaseRuleItem } from '@/lib/api/postPurchaseRules'

interface PostPurchaseRulesTableActionsProps {
	table: Table<PostPurchaseRuleItem>
	onRefresh: () => void
	isLoading: boolean
	storeId: string
}

/**
 * PostPurchaseRulesTableActions component for table toolbar actions
 */
export const PostPurchaseRulesTableActions = ({ table, onRefresh, isLoading, storeId }: PostPurchaseRulesTableActionsProps) => {
	const { t } = useTranslation('postPurchaseRules')
	return (
		<div className="flex items-center gap-2">
			<Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
				<RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
				{t('actions.refresh')}
			</Button>
		</div>
	)
}

